<div class="w-full create-activity-one cst-content-ctnr">
  <div class="w-full p-8 bg-zinc-100 dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex">
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div *ngIf="successMessage"
      class="py-2 fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40"
      [class.success-popup-fadeout]="isClosing">
      <div class="bg-white rounded-2xl shadow-2xl px-10 py-10 flex flex-col items-center gap-4 success-popup-anim">
        <svg class="success-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="success-checkmark-circle" cx="26" cy="26" r="24" fill="none" />
          <path class="success-checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
        <p class="text-lg font-semibold text-gray-800 text-center">
          {{ successMessage }}
        </p>
      </div>
    </div>
    <div *ngIf="errorMessage"
      class="py-2 fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
      <div class="bg-white rounded-2xl shadow-2xl px-10 py-10 flex flex-col items-center gap-4 error-popup-anim">
        <svg class="error-cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="error-cross-circle" cx="26" cy="26" r="24" fill="none" />
          <path class="error-cross-line1" fill="none" d="M17 17l18 18" />
          <path class="error-cross-line2" fill="none" d="M35 17l-18 18" />
        </svg>
        <p class="text-lg font-semibold text-gray-800 text-center">
          {{ errorMessage }}
        </p>
      </div>
    </div>

    <div class="self-stretch h-full flex-col justify-start items-start flex">
      <div class="self-stretch flex items-start justify-between pt-2 pb-4">
        <div class="flex-col justify-start items-start gap-1 flex">
          <div class="text-gray-900 text-3xl md:text-4xl leading-[38px]">
            Créer un nouveau Webinaire
          </div>
          <div class="w-2 h-1 rounded-full bg-emerald-500 mt-2 mb-2"></div>
          <p class="text-gray-500">
            Remplissez les informations ci-dessous pour planifier votre
            webinaire.
          </p>
        </div>
        <div class="hidden md:flex relative shrink-0" style="width: 96px; height: 96px">
          <div class="absolute inset-0 bg-blue-50 rounded-full"></div>
          <svg class="absolute" style="width: 44px; height: 44px; top: 26px; left: 26px" fill="none" viewBox="0 0 24 24"
            stroke="#2563eb" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 8.25A2.25 2.25 0 015.25 6h13.5A2.25 2.25 0 0121 8.25v7.5A2.25 2.25 0 0118.75 18H5.25A2.25 2.25 0 013 15.75v-7.5z" />
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9.75 21h4.5M12 18v3M9.75 10.5l2.25 2.25 3.75-3.75" />
          </svg>
          <span class="absolute bg-white rounded-full shadow flex items-center justify-center"
            style="width: 32px; height: 32px; top: -4px; right: -2px">
            <svg style="width: 18px; height: 18px" fill="none" viewBox="0 0 24 24" stroke="#10b981" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0V11.25a2.25 2.25 0 012.25-2.25h13.5a2.25 2.25 0 012.25 2.25v7.5" />
            </svg>
          </span>
        </div>
      </div>
      <div *ngIf="inValid"
        class="self-stretch flex items-center gap-2 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg"
        role="alert">
        <svg style="width: 20px; height: 20px" class="shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
        <span class="text-sm font-medium">Merci de remplir tous les champs</span>
      </div>
      <form
        class="self-stretch relative overflow-hidden bg-white rounded-2xl shadow-lg shadow-gray-200/60 border border-gray-200"
        [formGroup]="webinaireForm">
        <div class="h-1.5 w-full bg-gradient-to-r from-[#1264a1] via-[#3d99d8] to-emerald-500"></div>
        <section class="px-8 md:px-10 py-8 border-b border-gray-100">
          <div class="flex items-start gap-4 mb-7">
            <span
              class="inline-flex items-center justify-center rounded-full bg-gradient-to-br from-[#1264a1] to-[#2f8bcc] text-white text-sm font-semibold shadow-md shadow-[#1264a1]/30 ring-4 ring-[#1264a1]/[0.06]"
              style="width: 34px; height: 34px; min-width: 34px; flex: 0 0 34px">1</span>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 m-0">Informations générales</h3>
              <p class="text-sm text-gray-500 mt-0.5 mb-0">Identité, type et plateforme du webinaire.</p>
            </div>
          </div>

          <div class="space-y-5 p-3">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="name">
                  Nom du Webinaire <span class="text-red-500">*</span>
                </label>
                <div
                  class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                  [class.border-red-500]="inValidName" [class.border-gray-300]="!inValidName">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3 7.5A2.25 2.25 0 015.25 5.25h4.06c.414 0 .81.164 1.103.457l1.13 1.13c.293.293.69.457 1.103.457h8.104A2.25 2.25 0 0122.999 9.5v8.25A2.25 2.25 0 0120.75 20H3.25A2.25 2.25 0 011 17.75v-10.25z" />
                  </svg>
                  <input formControlName="name" id="name" type="text"
                    placeholder="Ex : Introduction à l'intelligence artificielle"
                    class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-0" />
                </div>
              </div>

              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="shortname">
                  Nom abrégé <span class="text-red-500">*</span>
                </label>
                <div
                  class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                  [class.border-red-500]="inValidShortname" [class.border-gray-300]="!inValidShortname">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z" />
                  </svg>
                  <input formControlName="shortname" id="shortname" type="text" placeholder="Ex : IA-2024"
                    class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-0" />
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="webinaireType">
                  Type de webinaire <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <div class="absolute inset-y-0 right-3.5 flex items-center pointer-events-none">
                    <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                      stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  <select id="webinaireType" formControlName="webinaireType" [disabled]="loadingWebinaireTypes"
                    class="w-full py-3 pl-4 pr-10 bg-white border border-gray-300 rounded-xl shadow-sm hover:shadow-md text-sm appearance-none transition focus:outline-none focus:border-gray-400 disabled:bg-gray-50 disabled:text-gray-400"
                    [class.text-gray-800]="!!webinaireForm.get('webinaireType')?.value"
                    [class.text-gray-400]="!webinaireForm.get('webinaireType')?.value">
                    <option value="" class="text-gray-400">{{ loadingWebinaireTypes ? 'Chargement...' : '-- Sélectionner
                      un type --' }}
                    </option>
                    <option *ngFor="let type of webinaireTypeOptions" [value]="type.value" class="text-gray-800">
                      {{ type.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700"
                  for="webinaireComposante">
                  Nom de la composante
                </label>
                <div class="relative">
                  <div class="absolute inset-y-0 right-3.5 flex items-center pointer-events-none">
                    <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                      stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  <select id="webinaireComposante" formControlName="webinaireComposante"
                    class="w-full py-3 pl-4 pr-10 bg-white border border-gray-300 rounded-xl shadow-sm hover:shadow-md text-sm appearance-none transition focus:outline-none focus:border-gray-400"
                    [class.text-gray-800]="!!webinaireForm.get('webinaireComposante')?.value"
                    [class.text-gray-400]="!webinaireForm.get('webinaireComposante')?.value">
                    <option value="" class="text-gray-400">-- Sélectionner une composante --</option>
                    <option *ngFor="let composante of webinaireComposanteOptions" [value]="composante.value"
                      class="text-gray-800">
                      {{ composante.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-x-6 gap-y-5" [ngClass]="{
                'sm:grid-cols-2': !webinaireForm.get('platform')?.value,
                'sm:grid-cols-3': webinaireForm.get('platform')?.value
              }">
              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="displayName">
                  Nom à afficher <span class="text-red-500">*</span>
                </label>
                <div
                  class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                  [class.border-red-500]="inValidDisplayName" [class.border-gray-300]="!inValidDisplayName">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                  </svg>
                  <input formControlName="displayName" id="displayName" type="text" placeholder="Nom à afficher"
                    class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-0" />
                </div>
              </div>

              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="platform">
                  Plateforme <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <div class="absolute inset-y-0 right-3.5 flex items-center pointer-events-none">
                    <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                      stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  <select id="platform" formControlName="platform"
                    class="w-full py-3 pl-4 pr-10 bg-white border border-gray-300 rounded-xl shadow-sm hover:shadow-md text-sm appearance-none transition focus:outline-none focus:border-gray-400"
                    [class.text-gray-800]="!!webinaireForm.get('platform')?.value"
                    [class.text-gray-400]="!webinaireForm.get('platform')?.value">
                    <option value="" class="text-gray-400">Sélectionner la plateforme</option>
                    <option value="zoom" class="text-gray-800">Zoom</option>
                    <option value="jokko" class="text-gray-800">Jokko</option>
                  </select>
                </div>
              </div>

              <div class="w-full" *ngIf="webinaireForm.get('platform')?.value === 'zoom'">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="zoomAccount500">
                  Capacité maximale <span class="text-red-500">*</span>
                </label>
                <div class="grid grid-cols-2 gap-3 rounded-lg pt-4" [class.ring-2]="inValidZoomAccount"
                  [class.ring-red-400]="inValidZoomAccount">
                  <label class="relative cursor-pointer">
                    <input id="zoomAccount500" type="radio" formControlName="zoomAccount" value="500"
                      class="peer sr-only" />
                    <span
                      class="flex items-center justify-center gap-1.5 py-3 px-3 rounded-xl border border-gray-300 shadow-sm bg-white text-sm text-gray-700 transition hover:border-gray-400 peer-checked:border-[#1264a1] peer-checked:bg-[#1264a1]/[0.06] peer-checked:text-[#1264a1] peer-checked:font-semibold peer-checked:shadow-md peer-checked:shadow-[#1264a1]/10">
                      500 <span class="hidden lg:inline">participants</span>
                    </span>
                  </label>
                  <label class="relative cursor-pointer">
                    <input type="radio" formControlName="zoomAccount" value="3000" class="peer sr-only" />
                    <span
                      class="flex items-center justify-center gap-1.5 py-3 px-3 rounded-xl border border-gray-300 shadow-sm bg-white text-sm text-gray-700 transition hover:border-gray-400 peer-checked:border-[#1264a1] peer-checked:bg-[#1264a1]/[0.06] peer-checked:text-[#1264a1] peer-checked:font-semibold peer-checked:shadow-md peer-checked:shadow-[#1264a1]/10">
                      3000 <span class="hidden lg:inline">participants</span>
                    </span>
                  </label>
                </div>
                <p *ngIf="inValidZoomAccount" class="mt-1.5 text-xs text-red-500">
                  Veuillez sélectionner la capacité maximale.
                </p>
              </div>

              <div class="w-full" *ngIf="webinaireForm.get('platform')?.value === 'jokko'">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="url">
                  Lien Jokko <span class="text-red-500">*</span>
                </label>
                <div
                  class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                  [class.border-red-500]="inValidUrlJokko || (webinaireForm.get('urlJokko')?.invalid && webinaireForm.get('urlJokko')?.touched)"
                  [class.border-gray-300]="!(inValidUrlJokko || (webinaireForm.get('urlJokko')?.invalid && webinaireForm.get('urlJokko')?.touched))">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                  </svg>
                  <input formControlName="urlJokko" id="url" type="url" placeholder="https://jokko.example.com/..."
                    class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-0" />
                </div>
                <p *ngIf="inValidUrlJokko" class="mt-1.5 text-xs text-red-500">
                  Le lien Jokko est obligatoire.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="px-8 md:px-10 py-8 border-b border-gray-100">
          <div class="flex items-start gap-4 mb-7">
            <span
              class="inline-flex items-center justify-center rounded-full bg-gradient-to-br from-[#1264a1] to-[#2f8bcc] text-white text-sm font-semibold shadow-md shadow-[#1264a1]/30 ring-4 ring-[#1264a1]/[0.06]"
              style="width: 34px; height: 34px; min-width: 34px; flex: 0 0 34px">2</span>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 m-0">Date et heure</h3>
              <p class="text-sm text-gray-500 mt-0.5 mb-0">Quand le webinaire aura-t-il lieu ?</p>
            </div>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-5 p-3">
            <div class="w-full">
              <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="date">
                Date du Webinaire <span class="text-red-500">*</span>
              </label>
              <div
                class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                [class.border-red-500]="inValidDate" [class.border-gray-300]="!inValidDate">
                <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0V11.25a2.25 2.25 0 012.25-2.25h13.5a2.25 2.25 0 012.25 2.25v7.5" />
                </svg>
                <input formControlName="date" id="date" type="date"
                  class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 focus:outline-none focus:ring-0" />
              </div>
            </div>

            <div class="w-full">
              <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="startTime">
                Heure de début <span class="text-red-500">*</span>
              </label>
              <div
                class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                [class.border-red-500]="inValidStartTime" [class.border-gray-300]="!inValidStartTime">
                <button type="button" (click)="openTimePicker(startTimeInput)" aria-label="Choisir l'heure de début"
                  class="shrink-0 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors">
                  <svg style="width: 18px; height: 18px" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6v6l4 2m5-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </button>
                <input #startTimeInput formControlName="startTime" id="startTime" type="time"
                  class="time-input w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 focus:outline-none focus:ring-0" />
              </div>
            </div>

            <div class="w-full">
              <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="endTime">
                Heure de fin <span class="text-red-500">*</span>
              </label>
              <div
                class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                [class.border-red-500]="inValidEndTime" [class.border-gray-300]="!inValidEndTime">
                <button type="button" (click)="openTimePicker(endTimeInput)" aria-label="Choisir l'heure de fin"
                  class="shrink-0 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors">
                  <svg style="width: 18px; height: 18px" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6v6l4 2m5-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </button>
                <input #endTimeInput formControlName="endTime" id="endTime" type="time"
                  class="time-input w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 focus:outline-none focus:ring-0" />
              </div>
            </div>
          </div>
        </section>
        <section class="px-8 md:px-10 py-8 border-b border-gray-100" *ngIf="isRenforcement">
          <div class="flex items-start gap-4 mb-7">
            <span
              class="inline-flex items-center justify-center rounded-full bg-gradient-to-br from-[#1264a1] to-[#2f8bcc] text-white text-sm font-semibold shadow-md shadow-[#1264a1]/30 ring-4 ring-[#1264a1]/[0.06]"
              style="width: 34px; height: 34px; min-width: 34px; flex: 0 0 34px">3</span>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 m-0">Cohorte ou période</h3>
              <p class="text-sm text-gray-500 mt-0.5 mb-0">
                Rattachez ce webinaire de renforcement soit à une période d'ouverture, soit à une cohorte
                existante. Un seul choix possible.
              </p>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5 p-3" role="group"
            aria-label="Choix période ou cohorte">
            <label
              class="relative flex items-center gap-3.5 p-5 rounded-2xl border-2 cursor-pointer transition-all hover:shadow-md"
              [ngClass]="periodMode === 'periode' ? 'border-[#1264a1] bg-[#1264a1]/[0.06] shadow-md shadow-[#1264a1]/10' : 'border-gray-200 bg-white hover:border-gray-300'">
              <input type="checkbox" class="sr-only" [checked]="periodMode === 'periode'"
                (change)="selectPeriodMode('periode', $event)" />
              <span class="inline-flex items-center justify-center rounded-xl shrink-0 transition-colors"
                style="width: 46px; height: 46px"
                [ngClass]="periodMode === 'periode' ? 'bg-[#1264a1] text-white' : 'bg-gray-100 text-gray-500'">
                <svg style="width: 20px; height: 20px" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  stroke-width="1.7">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0V11.25a2.25 2.25 0 012.25-2.25h13.5a2.25 2.25 0 012.25 2.25v7.5" />
                </svg>
              </span>
              <span class="flex-1 min-w-0">
                <span class="block text-sm font-semibold text-gray-900">Période</span>
                <span class="block text-xs text-gray-500 mt-0.5">Intervalle d'ouverture (début et fin)</span>
              </span>
              <span class="inline-flex items-center justify-center rounded-md border-2 shrink-0 transition-colors"
                style="width: 20px; height: 20px"
                [ngClass]="periodMode === 'periode' ? 'bg-[#1264a1] border-[#1264a1]' : 'bg-white border-gray-300'">
                <svg *ngIf="periodMode === 'periode'" style="width: 14px; height: 14px" fill="none" viewBox="0 0 24 24"
                  stroke="white" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
            </label>
            <label
              class="relative flex items-center gap-3.5 p-5 rounded-2xl border-2 cursor-pointer transition-all hover:shadow-md"
              [ngClass]="periodMode === 'cohorte' ? 'border-[#1264a1] bg-[#1264a1]/[0.06] shadow-md shadow-[#1264a1]/10' : 'border-gray-200 bg-white hover:border-gray-300'">
              <input type="checkbox" class="sr-only" [checked]="periodMode === 'cohorte'"
                (change)="selectPeriodMode('cohorte', $event)" />
              <span class="inline-flex items-center justify-center rounded-xl shrink-0 transition-colors"
                style="width: 46px; height: 46px"
                [ngClass]="periodMode === 'cohorte' ? 'bg-[#1264a1] text-white' : 'bg-gray-100 text-gray-500'">
                <svg style="width: 20px; height: 20px" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  stroke-width="1.7">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                </svg>
              </span>
              <span class="flex-1 min-w-0">
                <span class="block text-sm font-semibold text-gray-900">Cohorte</span>
                <span class="block text-xs text-gray-500 mt-0.5">Rattacher à une cohorte existante</span>
              </span>
              <span class="inline-flex items-center justify-center rounded-md border-2 shrink-0 transition-colors"
                style="width: 20px; height: 20px"
                [ngClass]="periodMode === 'cohorte' ? 'bg-[#1264a1] border-[#1264a1]' : 'bg-white border-gray-300'">
                <svg *ngIf="periodMode === 'cohorte'" style="width: 14px; height: 14px" fill="none" viewBox="0 0 24 24"
                  stroke="white" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
            </label>
          </div>
          <div *ngIf="periodMode === 'cohorte'"
            class="rounded-2xl border border-[#1264a1]/20 bg-gradient-to-br from-[#1264a1]/[0.06] to-white p-6 md:p-7">
            <div class="max-w-md">
              <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="cohorte">
                Cohorte <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <div class="absolute inset-y-0 left-3.5 flex items-center pointer-events-none">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                  </svg>
                </div>
                <div class="absolute inset-y-0 right-3.5 flex items-center pointer-events-none">
                  <svg class="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
                <select id="cohorte" formControlName="cohorte"
                  class="w-full py-3 pl-10 pr-10 bg-white border rounded-xl shadow-sm hover:shadow-md text-sm appearance-none transition focus:outline-none focus:border-gray-400"
                  [class.border-red-500]="inValidCohorte" [class.border-gray-300]="!inValidCohorte"
                  [class.text-gray-800]="!!webinaireForm.get('cohorte')?.value"
                  [class.text-gray-400]="!webinaireForm.get('cohorte')?.value">
                  <option value="" disabled class="text-gray-400">Sélectionner une cohorte</option>
                  <option *ngFor="let cohorte of cohorteOptions" [value]="cohorte" class="text-gray-800">
                    {{ cohorte }}
                  </option>
                </select>
              </div>
              <p *ngIf="!cohorteOptions.length" class="mt-1.5 text-xs text-gray-400">
                Aucune cohorte récente disponible pour le moment.
              </p>
              <p *ngIf="inValidCohorte" class="mt-1.5 text-xs text-red-500">
                Veuillez sélectionner une cohorte.
              </p>
            </div>
          </div>
          <div *ngIf="periodMode === 'periode'"
            class="rounded-2xl border border-[#1264a1]/20 bg-gradient-to-br from-[#1264a1]/[0.06] to-white p-6 md:p-7">
            <p class="text-gray-600 text-sm leading-relaxed mb-6 mt-0 pl-3.5 border-l-2 border-[#1264a1]/40">
              La période correspond à l'intervalle global durant lequel le webinaire est ouvert, à ne pas
              confondre avec la date précise du webinaire renseignée ci-dessus. Indiquez une date de début et
              une date de fin : la durée sera calculée automatiquement.
            </p>

            <div class="grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-5">
              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="periodStart">
                  Date de début de la période <span class="text-red-500">*</span>
                </label>
                <div
                  class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                  [class.border-red-500]="inValidPeriod" [class.border-gray-300]="!inValidPeriod">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0V11.25a2.25 2.25 0 012.25-2.25h13.5a2.25 2.25 0 012.25 2.25v7.5" />
                  </svg>
                  <input formControlName="periodStart" id="periodStart" type="date"
                    class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 focus:outline-none focus:ring-0" />
                </div>
              </div>

              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700" for="periodEnd">
                  Date de fin de la période <span class="text-red-500">*</span>
                </label>
                <div
                  class="group flex items-center gap-2.5 bg-white rounded-xl border px-4 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                  [class.border-red-500]="inValidPeriod" [class.border-gray-300]="!inValidPeriod">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0 transition-colors" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0V11.25a2.25 2.25 0 012.25-2.25h13.5a2.25 2.25 0 012.25 2.25v7.5" />
                  </svg>
                  <input formControlName="periodEnd" id="periodEnd" type="date"
                    class="w-full py-2.5 bg-transparent border-0 text-sm text-gray-800 focus:outline-none focus:ring-0" />
                </div>
              </div>

              <div class="w-full">
                <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700">Durée de la
                  période</label>
                <div
                  class="flex items-center gap-2.5 bg-[#1264a1]/[0.06] rounded-xl border border-[#1264a1]/20 px-4 py-2.5">
                  <svg style="width: 18px; height: 18px" class="text-gray-400 shrink-0" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="1.6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6v6l4 2m5-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span class="text-sm font-semibold text-[#1264a1]">
                    {{ dureePeriodeLabel || "—" }}
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="inValidPeriod"
              class="flex items-center gap-2 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg mt-4"
              role="alert">
              <svg style="width: 20px; height: 20px" class="shrink-0" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
              <span class="text-sm font-medium">La date de fin de la période doit être postérieure ou égale
                à la date de début.</span>
            </div>
          </div>
        </section>
        <section class="px-8 md:px-10 py-8">
          <div class="flex items-start gap-4 mb-7">
            <span
              class="inline-flex items-center justify-center rounded-full bg-gradient-to-br from-[#1264a1] to-[#2f8bcc] text-white text-sm font-semibold shadow-md shadow-[#1264a1]/30 ring-4 ring-[#1264a1]/[0.06]"
              style="width: 34px; height: 34px; min-width: 34px; flex: 0 0 34px">{{ isRenforcement ? 4 : 3 }}</span>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 m-0">Contenu</h3>
              <p class="text-sm text-gray-500 mt-0.5 mb-0">Présentez le webinaire aux participants.</p>
            </div>
          </div>

          <div class="space-y-5">
            <div>
              <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700"
                for="objectif">Objectif</label>
              <div
                class="group flex items-start gap-2.5 bg-white rounded-xl border px-4 py-2.5 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                [class.border-red-500]="inValidObjectif" [class.border-gray-300]="!inValidObjectif">
                <svg style="width: 18px; height: 18px; margin-top: 2px" class="text-gray-400 shrink-0 transition-colors"
                  fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                </svg>
                <textarea formControlName="objectif" id="objectif" rows="3"
                  placeholder="Décrivez l'objectif de ce webinaire, ce que les participants vont apprendre ou découvrir."
                  class="w-full bg-transparent border-0 p-0 text-sm text-gray-800 placeholder:text-gray-400 resize-none focus:outline-none focus:ring-0"
                  maxlength="300"></textarea>
              </div>
              <p class="mt-1 mb-0 text-right text-xs text-gray-400">
                {{ webinaireForm.get('objectif')?.value?.length || 0 }}/300
              </p>
            </div>

            <div>
              <label class="mb-2 block text-[13px] font-semibold tracking-wide text-gray-700"
                for="description">Description</label>
              <div
                class="group flex items-start gap-2.5 bg-white rounded-xl border px-4 py-2.5 shadow-sm transition hover:shadow-md focus-within:border-gray-400"
                [class.border-red-500]="inValidDescription" [class.border-gray-300]="!inValidDescription">
                <svg style="width: 18px; height: 18px; margin-top: 2px" class="text-gray-400 shrink-0 transition-colors"
                  fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-1.519-3.87a.938.938 0 111.326 1.326m-1.326-1.326L12 15m2.481-2.62l1.326 1.326M9 12h3.75M9 15.75h3.75M9 8.25h1.5" />
                </svg>
                <textarea formControlName="description" id="description" rows="4"
                  placeholder="Décrivez en détail le contenu du webinaire, le programme, les intervenants et toute information utile pour les participants."
                  class="w-full bg-transparent border-0 p-0 text-sm text-gray-800 placeholder:text-gray-400 resize-none focus:outline-none focus:ring-0"
                  maxlength="300"></textarea>
              </div>
              <p class="mt-1 mb-0 text-right text-xs text-gray-400">
                {{ webinaireForm.get('description')?.value?.length || 0 }}/300
              </p>
            </div>
          </div>

          <div
            class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-4 mt-10 pt-6 border-t border-gray-100">
            <p class="text-xs text-gray-400 m-0"><span class="text-red-500">*</span> Champs obligatoires</p>
            <div class="flex items-center justify-end gap-3">
              <button type="button" (click)="resetCreation()"
                class="text-sm text-gray-700 font-semibold px-5 py-3 bg-white hover:bg-gray-50 rounded-xl shadow-sm border border-gray-300 cursor-pointer transition">
                Annuler
              </button>
              <button type="submit" (click)="createWebinaire()" [disabled]="valid || isSaving"
                [attr.aria-busy]="isSaving"
                class="inline-flex items-center justify-center gap-2 min-w-[150px] text-sm text-white font-semibold px-6 py-3 bg-gradient-to-r from-[#1264a1] to-[#2f8bcc] hover:from-[#0f558a] hover:to-[#2678b8] disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0 rounded-xl shadow-lg shadow-[#1264a1]/25 hover:-translate-y-px cursor-pointer transition-all">
                <svg *ngIf="isSaving" class="animate-spin" style="width: 18px; height: 18px" fill="none"
                  viewBox="0 0 24 24" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25" />
                  <path fill="currentColor" style="opacity: 0.85" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
                <svg *ngIf="!isSaving" style="width: 18px; height: 18px" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2.2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                {{ isSaving ? 'Enregistrement…' : 'Enregistrer' }}
              </button>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
<div *ngIf="showConfirmWebinaireModal"
  class="fixed inset-0 z-[99999999] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-opacity duration-200">

  <div
    class="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-4  transform transition-all duration-200 scale-100 opacity-100">
    <div
      class="flex items-center justify-center w-2 h-12 rounded-full bg-blue-100 text-blue-600 mx-auto mb-4 ring-8 ring-blue-50">
      <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    </div>
    <div class="text-center mb-6">
      <h2 class="text-xl font-bold text-gray-900 tracking-tight">
        Confirmer la création
      </h2>
      <p class="text-xs text-gray-500 mt-1">
        Vérifiez les informations ci-dessous avant de valider la création du webinaire.
      </p>
    </div>

    <div
      class="bg-gray-50/80 rounded-xl border border-gray-100 p-4 mb-6 divide-y divide-gray-200/60 text-xs sm:text-sm">
      <div class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Nom</span>
        <span class="font-semibold text-gray-900 text-right truncate">{{ pendingWebinaireDto?.name }}</span>
      </div>

      <div class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Date</span>
        <span class="font-semibold text-gray-900">{{ pendingWebinaireDto?.date | date: "dd/MM/yyyy" }}</span>
      </div>

      <div class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Heure</span>
        <span class="font-semibold text-gray-900">
          {{ pendingWebinaireDto?.startTime | slice: 0 : 5 }} — {{ pendingWebinaireDto?.endTime | slice: 0 : 5 }}
        </span>
      </div>

      <div class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Plateforme</span>
        <span
          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 capitalize">
          {{ pendingWebinaireDto?.plateforme }}
        </span>
      </div>

      <div *ngIf="pendingWebinaireDto?.plateforme === 'zoom'"
        class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Capacité</span>
        <span class="font-semibold text-gray-900">{{ pendingWebinaireDto?.zoomAccount }} participants</span>
      </div>

      <div *ngIf="pendingWebinaireDto?.webinaireType"
        class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Type</span>
        <span class="font-semibold text-gray-900">{{ pendingWebinaireDto?.webinaireType }}</span>
      </div>

      <div *ngIf="pendingWebinaireDto?.webinaireComposante"
        class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Composante</span>
        <span class="font-semibold text-gray-900">{{ pendingWebinaireDto?.webinaireComposante }}</span>
      </div>

      <div *ngIf="pendingWebinaireDto?.periodStart && pendingWebinaireDto?.periodEnd"
        class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Période</span>
        <span class="font-semibold text-gray-900 text-right">
          {{ pendingWebinaireDto?.periodStart | date: "dd/MM/yyyy" }} — {{ pendingWebinaireDto?.periodEnd | date:
          "dd/MM/yyyy" }}
          <span *ngIf="dureePeriodeLabel" class="text-xs text-gray-500 font-normal">({{ dureePeriodeLabel }})</span>
        </span>
      </div>

      <div *ngIf="pendingWebinaireDto?.cohorte"
        class="py-2 first:pt-0 last:pb-0 flex justify-between items-center gap-2">
        <span class="font-medium text-gray-500">Cohorte</span>
        <span class="font-semibold text-gray-900">{{ pendingWebinaireDto?.cohorte }}</span>
      </div>
    </div>


    <div class="flex items-center justify-end gap-3">
      <button (click)="cancelWebinaireCreation()" type="button"
        class="w-full sm:w-auto px-4 py-2.5 bg-white hover:bg-gray-100 text-gray-700 text-sm font-semibold rounded-xl border border-gray-300 shadow-sm transition active:scale-95 focus:outline-none focus:ring-2 focus:ring-gray-200">
        Annuler
      </button>
      <button (click)="confirmWebinaireCreation()" type="button"
        class="w-full sm:w-auto px-5 py-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-semibold rounded-xl shadow-md shadow-blue-500/20 transition active:scale-95 focus:outline-none focus:ring-2 focus:ring-blue-500/50">
        Confirmer
      </button>
    </div>

  </div>
</div>